// UI monolíngue por ora: o texto vem do bundle pt-BR direto, não do i18next
// (ver i18n/README.md — trocar o idioma padrão é trocar este caminho).
import signup from '@/i18n/locales/pt-BR/signup.json';

export const signupCopy = {
  productName: 'identila',
  title: signup.title,
  subtitle: signup.subtitle,
  fullNameLabel: signup.fullNameLabel,
  fullNamePlaceholder: signup.fullNamePlaceholder,
  emailLabel: signup.emailLabel,
  emailPlaceholder: signup.emailPlaceholder,
  birthDateLabel: signup.birthDateLabel,
  nationalityLabel: signup.nationalityLabel,
  cpfLabel: signup.cpfLabel,
  cpfPlaceholder: signup.cpfPlaceholder,
  documentLabel: signup.documentLabel,
  documentPlaceholder: signup.documentPlaceholder,
  cta: signup.cta,
  ctaLoading: signup.ctaLoading,
  securityMessage: signup.securityMessage,
} as const;

export const signupValidationMessages = signup.validation;
